import { Observable } from 'rxjs';
import { IHttpHeaders, IHttpParameters } from 'projects/models/src/public-api';
import { InjectionToken } from '@angular/core';

export const HTTP_API_URL = new InjectionToken<string>('HttpService API Base URL for all requests');
export const HTTP_PRESENTAION_URL = new InjectionToken<string>('Presentation URL for all requests');

export abstract class NgHttpService {
    abstract get<T>(endpoint: string, headers?: IHttpHeaders, parameters?: IHttpParameters): Observable<T>;
    abstract post<T>(endpoint: string, headers?: IHttpHeaders, parameters?: IHttpParameters, body?: any): Observable<T>;
    abstract put<T>(endpoint: string, headers?: IHttpHeaders, params?: IHttpParameters, body?: any): Observable<T>;
    abstract delete<T>(endpoint: string, headers?: IHttpHeaders, params?: IHttpParameters): Observable<T>;
}
